<template>
    <h2>Operations Pages</h2>
    <div    class="flex justify-around">
        <div    class="w-3/5 grid-cols-12">
            <!-- List of links that should be shown -->
            <ul class="mt-3 grid grid-cols-1 gap-5 sm:gap-5 md:grid-cols-2">
                <!-- Grab each links -->
                <template v-for="link in links">
                    <li     v-if="canSeeLink(link)"
                            class="col-span-1">
                        <!-- Link to page -->
                        <setting-page-link-with-icon    :href="link.link"
                                                        :icon="link.icon"
                                                        :text="link.text"
                        ></setting-page-link-with-icon>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import SettingPageLinkWithIcon from "@/components/SonicuSidebar/SettingPageLinkWithIcon.vue";
import {SidebarLinksPageMixin} from "@/mixins/SidebarLinksPageMixin";

export default {
    name: "OperationsLinksPage",
    mixins: [SonicuCoreMixin, iconNamesMixin, SidebarLinksPageMixin],
    components: {SettingPageLinkWithIcon},
    emits: [],
    props: {},
    data() {
        return {
            links: [
                {
                    text: 'SNAP Recalibration Report',
                    link: '/$company/reports/snap-recalibration-report',
                    permission: 'run_snap_recalibration_report',
                    icon: 'icon-file-spreadsheet',
                },
                {
                    text: 'Upload Image',
                    link: '/$company/settings/system-settings',
                    permission: 'upload_image',
                    icon: 'icon-cloud-upload',
                },
                {
                    text: 'Companies',
                    link: '/SonicuTools/Companies',
                    permission: 'read_companies',
                    icon: 'icon-city',
                    show: () => {
                        return this.company.getCompanyId() === 'sonicu'
                    }
                },
                {
                    text: 'Device Profile Template',
                    link: '/$company/device-profile-template',
                    permission: 'view_device_profile_template',
                    icon: 'icon-flash-memory',
                },
                {
                    text: 'Enterprise Report',
                    link: '/$company/enterprise-dashboard-report',
                    permission: 'edit_enterprise_status_report',
                    icon: 'icon-file-charts',
                },
                {
                    text: 'User Export',
                    link: '/export-users',
                    permission: 'export_users',
                    icon: 'icon-clipboard-text',
                },
                {
                    text: 'Probe Calibration Audits',
                    link: '/$company/probe-calibration-audit',
                    permission: 'view_probe_calibration_audit',
                    icon: 'icon-clipboard-text',
                },
                {
                    text: 'Enhanced Audits',
                    link: '/enhanced-audits',
                    permission: 'view_enhanced_audits',
                    icon: 'icon-register',
                },
                {
                    text: 'All Kickstart Installations',
                    link: '/sonicu/kickstart-installations',
                    permission: 'view_kickstart_installations',
                    icon: 'icon-rocket',
                    show: () => {
                        return this.company.getCompanyId() === 'sonicu'
                    }
                },
            ],
        }
    },
    created() {
        this.links = this.parseCompanyLinks(this.links)
    },
    mounted() {

    },
    methods: {},
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>